import { render, staticRenderFns } from "./logo-abx.vue?vue&type=template&id=ddda55d0&scoped=true&"
import script from "./logo-abx.vue?vue&type=script&lang=js&"
export * from "./logo-abx.vue?vue&type=script&lang=js&"
import style0 from "./logo-abx.vue?vue&type=style&index=0&id=ddda55d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddda55d0",
  null
  
)

export default component.exports